export var DAY_SIZE = 36;
export var DAY_MARGIN = 2;
export var DIALOG_WIDTH = 320;
export var MAX_CALENDAR_HEIGHT = 280;
export var VIEW_HEIGHT = 334;
export var DIGITAL_CLOCK_VIEW_HEIGHT = 232;
export var MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;